import Image from 'next/image';
import { SVGProps } from 'react';

const SVGParachute = ({ width = '124px', height = '181px' }: SVGProps<SVGElement>) => {
  return <Image src="/svgs/parachute.svg" alt="Parachute" width={width} height={height} />;
};

export default SVGParachute;
